import { createFileRoute } from '@tanstack/react-router';
import { ReferenceDataManager } from '@/features/admin/ReferenceDataManager';

export const Route = createFileRoute('/admin/reference/occupations')({
  component: OccupationsAdmin,
});

function OccupationsAdmin() {
  return (
    <ReferenceDataManager resource="occupations" singular="occupation" />
  );
}
